import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { Button, Modal } from 'antd';

import { colors } from '../../utils/variables.styles';

import EditableSection from '../../components/EditableSection';
import SelectEdit from '../../components/SelectEdit';

import selector from './windowsEditor.selector';

import { infoShape } from '../../types/info.types';
import { availableType } from '../../types/available.types';

import {
  selectFirstHeight,
  selectLength,
  selectSecondHeight,
  selectWidth,
  setSelected as setSelectedParameter,
  setWindows
} from '../Construction/construction.reducer';
import withTranslation from "../../components/WithTranslation/WithTranslation";
import { InfoCircleOutlined } from "@ant-design/icons";
import RangeEdit from "../../components/RangeEdit/RangeEdit";

const Container = styled.div`
  background: ${colors.whiteer};
  padding: 10px 24px;
  margin-left: -27px;
`;

const Spacer = styled.div`
  padding: 10px 24px;
  font-weight: 600;
  max-width: 280px;
`;

const ImgWrapper = styled.img`
  max-width: 100%;
  display: block;
  margin: 15px auto;
`;

const ButtonWrapper = styled.div`
  padding-top: 5px;
`;

// 2 -> "no", 3 -> "yes"
const TILT_OPTIONS = [
  { id: 2, key: 'no' },
  { id: 3, key: 'yes' },
];

const COLOR_OPTIONS = [
  { id: 1, key: 'white' },
  { id: 2, key: 'color' },
];

const getSelectedSize = (available, selectedId) => {
  const opt = available?.find((el) => el.id === selectedId);
  if (!opt) return { width: 0, height: 0 };

  const str = String(opt.value || '').toLowerCase();
  const m = str.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
  if (!m) return { width: 0, height: 0 };

  return {
    width: Number(m[1]) || 0,
    height: Number(m[2]) || 0,
  };
};

const ConstructionExtras = ({
                              collapsed,
                              loaded = false,

                              // BACK
                              window_back_count_available = [],
                              window_back_count_info = null,
                              window_back_count_selected = null,
                              window_back_size_available = [],
                              window_back_size_info = null,
                              window_back_size_selected = null,

                              // LEFT
                              window_left_count_available = [],
                              window_left_count_info = null,
                              window_left_count_selected = null,
                              window_left_size_available = [],
                              window_left_size_info = null,
                              window_left_size_selected = null,

                              // RIGHT
                              window_right_count_available = [],
                              window_right_count_info = null,
                              window_right_count_selected = null,
                              window_right_size_available = [],
                              window_right_size_info = null,
                              window_right_size_selected = null,

                              // FRONT ✅ DODANE
                              window_front_count_available = [],
                              window_front_count_info = null,
                              window_front_count_selected = null,
                              window_front_size_available = [],
                              window_front_size_info = null,
                              window_front_size_selected = null,

                              // tilt
                              window_back_tilt_selected,
                              window_left_tilt_selected,
                              window_right_tilt_selected,
                              window_front_tilt_selected,

                              // color
                              window_back_color_selected,
                              window_left_color_selected,
                              window_right_color_selected,
                              window_front_color_selected,

                              setSelected,
                              t
                            }) => {
  const openModal = () => {
    Modal.info({
      title: window_back_count_info && window_back_count_info.info_title,
      content: (
        <>
          {window_back_count_info ? (
            <>
              {window_back_count_info.img_one ? <ImgWrapper src={window_back_count_info.img_one} /> : null}
              {window_back_count_info.img_two ? <ImgWrapper src={window_back_count_info.img_two} /> : null}
              {window_back_count_info.info_content}
              {window_back_count_info.img_three ? <ImgWrapper src={window_back_count_info.imgimg_three_one} /> : null}
              {window_back_count_info.img_four ? <ImgWrapper src={window_back_count_info.img_four} /> : null}
            </>
          ) : null}
        </>
      )
    });
  };

  const width = useSelector(selectWidth);
  const length = useSelector(selectLength);
  const firstHeight = useSelector(selectFirstHeight);
  const secondHeight = useSelector(selectSecondHeight);

  const dispatch = useDispatch();
  const windows = useSelector((state) => state.Construction.windows);

  const onWindowPositionChange = (wall, windowType, index, horizontalVertical, value) => {
    const updatedWindowsArray = (windows[wall]?.[windowType] || []).map((d, i) =>
      i === index ? { ...d, [horizontalVertical]: value } : d
    );

    dispatch(setWindows(wall, windowType, updatedWindowsArray));
  };

  const getPcvWindowsCount = (countId) => {
    if (countId === 20) return 0;
    if (countId === 21) return 1;
    if (countId === 22) return 2;
    return 0;
  };

  const handleWindowCountChange = (
    wall,
    windowType,
    paramKey,
    countId,
    sizeAvailable,
    sizeSelectedId
  ) => {
    let windowsCount = 0;

    if (windowType === 'pcv') {
      windowsCount = getPcvWindowsCount(countId);
    }

    const { width: winW, height: winH } = getSelectedSize(sizeAvailable, sizeSelectedId);

    const current = windows[wall]?.[windowType] || [];
    const updatedWindows = Array.from({ length: windowsCount }, (_, index) => {
      const existing = current[index];
      if (existing) {
        return {
          ...existing,
          width: typeof existing.width === 'number' && existing.width > 0 ? existing.width : winW,
          height: typeof existing.height === 'number' && existing.height > 0 ? existing.height : winH
        };
      }
      return {
        id: index,
        positionHorizontal: 20,
        positionVertical: 50,
        width: winW || 80,
        height: winH || 60,
      };
    });

    dispatch(setWindows(wall, windowType, updatedWindows));
    setSelected(paramKey, countId);
  };

  const handleWindowSizeChange = (wall, windowType, paramKey, sizeId, sizeAvailable) => {
    const { width: winW, height: winH } = getSelectedSize(sizeAvailable, sizeId);
    const current = windows[wall]?.[windowType] || [];

    const updated = current.map((w) => ({
      ...w,
      width: winW,
      height: winH
    }));

    dispatch(setWindows(wall, windowType, updated));
    setSelected(paramKey, sizeId);
  };

  const getTiltOptions = (sizeSelected) => {
    if (!sizeSelected) return [];

    const sizeId = Number(sizeSelected);
    let allowedIds;

    switch (sizeId) {
      case 23:
      case 52:
      case 55:
        allowedIds = [3];
        break;
      case 54:
        allowedIds = [2];
        break;
      case 53:
        allowedIds = [2, 3];
        break;
      default:
        allowedIds = [2, 3];
    }

    return TILT_OPTIONS
      .filter((opt) => allowedIds.includes(opt.id))
      .map((opt) => ({
        id: opt.id,
        value: t(opt.key) || opt.key,
      }));
  };

  const getColorOptions = () => {
    return COLOR_OPTIONS.map((opt) => ({
      id: opt.id,
      value: t(opt.key) || (opt.key === 'white' ? 'Biały' : 'Kolor'),
    }));
  };

  const colorInfo = {
    category: 'windows',
    action: 'color',
    name: t('window_color_info_title'),
    info_title: t('window_color_info_title'),
    info_content: t('window_color_info_content'),
  };

  // BACK auto-select tilt (gdy tylko 1 opcja)
  useEffect(() => {
    if (!loaded) return;
    if (!(window_back_count_selected > 0 && window_back_size_selected)) return;
    if (window_back_tilt_selected) return;

    const opts = getTiltOptions(window_back_size_selected);
    if (opts.length === 1) setSelected('window_back_tilt', opts[0].id);
  }, [loaded, window_back_count_selected, window_back_size_selected, window_back_tilt_selected, setSelected]);

  // LEFT auto-select tilt
  useEffect(() => {
    if (!loaded) return;
    if (!(window_left_count_selected > 0 && window_left_size_selected)) return;
    if (window_left_tilt_selected) return;

    const opts = getTiltOptions(window_left_size_selected);
    if (opts.length === 1) setSelected('window_left_tilt', opts[0].id);
  }, [loaded, window_left_count_selected, window_left_size_selected, window_left_tilt_selected, setSelected]);

  // RIGHT auto-select tilt
  useEffect(() => {
    if (!loaded) return;
    if (!(window_right_count_selected > 0 && window_right_size_selected)) return;
    if (window_right_tilt_selected) return;

    const opts = getTiltOptions(window_right_size_selected);
    if (opts.length === 1) setSelected('window_right_tilt', opts[0].id);
  }, [loaded, window_right_count_selected, window_right_size_selected, window_right_tilt_selected, setSelected]);

  // FRONT ✅ auto-select tilt
  useEffect(() => {
    if (!loaded) return;
    if (!(window_front_count_selected > 0 && window_front_size_selected)) return;
    if (window_front_tilt_selected) return;

    const opts = getTiltOptions(window_front_size_selected);
    if (opts.length === 1) setSelected('window_front_tilt', opts[0].id);
  }, [loaded, window_front_count_selected, window_front_size_selected, window_front_tilt_selected, setSelected]);

  return (
    <>
      {loaded ? (
        <EditableSection
          collapsed={collapsed}
          title={t('pvc_tilt_windows')}
          nested
          subsection={true}
          open={false}
        >
          <Spacer>{t('please_describe_location_of_windows')}</Spacer>

          {/* BACK WALL */}
          <SelectEdit
            selected={window_back_count_selected}
            loaded={loaded}
            title={window_back_count_info?.name}
            onChange={(id) =>
              handleWindowCountChange(
                'back_wall',
                'pcv',
                'window_back_count',
                id,
                window_back_size_available,
                window_back_size_selected
              )
            }
            options={window_back_count_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          <SelectEdit
            selected={window_back_size_selected}
            loaded={loaded}
            title={window_back_size_info?.name}
            onChange={(id) =>
              handleWindowSizeChange('back_wall', 'pcv', 'window_back_size', id, window_back_size_available)
            }
            options={window_back_size_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          {windows['back_wall']?.pcv?.map((window, index) => (
            <React.Fragment key={`${window.id}_group`}>
              <RangeEdit
                key={`${window.id}_horizontal`}
                title={
                  windows['back_wall'].pcv.length === 1
                    ? t('window_pcv_position_horizontal')
                    : `${t('window_pcv_position_horizontal')} ${index + 1}`
                }
                min={20}
                step={5}
                max={width - 20 - window.width}
                unit={'cm'}
                selected={window.positionHorizontal}
                onChange={(value) => onWindowPositionChange('back_wall', 'pcv', index, 'positionHorizontal', value)}
              />
              <RangeEdit
                key={`${window.id}_vertical`}
                title={
                  windows['back_wall'].pcv.length === 1
                    ? t('window_pcv_position_vertical')
                    : `${t('window_pcv_position_vertical')} ${index + 1}`
                }
                min={50}
                step={5}
                max={secondHeight - 13 - window.height}
                unit={'cm'}
                selected={window.positionVertical ?? 50}
                onChange={(value) => onWindowPositionChange('back_wall', 'pcv', index, 'positionVertical', value)}
              />
            </React.Fragment>
          ))}
          {window_back_count_selected > 0 && window_back_size_selected && (
            <>
              <SelectEdit
                selected={window_back_tilt_selected}
                loaded={loaded}
                title={t('tilt_window_back') || t('tilt_window') || 'Uchylne (tył)'}
                onChange={(id) => { setSelected('window_back_tilt', id); }}
                options={getTiltOptions(window_back_size_selected)}
                nested
              />
              <SelectEdit
                selected={window_back_color_selected}
                loaded={loaded}
                title={t('window_back_color') || 'Kolor okna (tył)'}
                onChange={(id) => { setSelected('window_back_color', id); }}
                options={getColorOptions()}
                nested
                info={colorInfo}
              />
            </>
          )}

          {/* LEFT WALL */}
          <SelectEdit
            selected={window_left_count_selected}
            loaded={loaded}
            title={window_left_count_info?.name}
            onChange={(id) =>
              handleWindowCountChange(
                'left_wall',
                'pcv',
                'window_left_count',
                id,
                window_left_size_available,
                window_left_size_selected
              )
            }
            options={window_left_count_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          <SelectEdit
            selected={window_left_size_selected}
            loaded={loaded}
            title={window_left_size_info?.name}
            onChange={(id) =>
              handleWindowSizeChange('left_wall', 'pcv', 'window_left_size', id, window_left_size_available)
            }
            options={window_left_size_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          {windows['left_wall']?.pcv?.map((window, index) => (
            <React.Fragment key={`${window.id}_group`}>
              <RangeEdit
                key={`${window.id}_horizontal`}
                title={
                  windows['left_wall'].pcv.length === 1
                    ? t('window_pcv_position_horizontal')
                    : `${t('window_pcv_position_horizontal')} ${index + 1}`
                }
                min={20}
                step={5}
                max={length - 20 - window.width}
                unit={'cm'}
                selected={window.positionHorizontal}
                onChange={(value) => onWindowPositionChange('left_wall', 'pcv', index, 'positionHorizontal', value)}
              />
              <RangeEdit
                key={`${window.id}_vertical`}
                title={
                  windows['left_wall'].pcv.length === 1
                    ? t('window_pcv_position_vertical')
                    : `${t('window_pcv_position_vertical')} ${index + 1}`
                }
                min={50}
                step={5}
                max={secondHeight - 13 - window.height}
                unit={'cm'}
                selected={window.positionVertical ?? 50}
                onChange={(value) => onWindowPositionChange('left_wall', 'pcv', index, 'positionVertical', value)}
              />
            </React.Fragment>
          ))}
          {window_left_count_selected > 0 && window_left_size_selected && (
            <>
              <SelectEdit
                selected={window_left_tilt_selected}
                loaded={loaded}
                title={t('tilt_window_left') || t('tilt_window') || 'Uchylne (lewa)'}
                onChange={(id) => { setSelected('window_left_tilt', id); }}
                options={getTiltOptions(window_left_size_selected)}
                nested
              />
              <SelectEdit
                selected={window_left_color_selected}
                loaded={loaded}
                title={t('window_left_color') || 'Kolor okna (lewa)'}
                onChange={(id) => { setSelected('window_left_color', id); }}
                options={getColorOptions()}
                nested
                info={colorInfo}
              />
            </>
          )}

          {/* RIGHT WALL */}
          <SelectEdit
            selected={window_right_count_selected}
            loaded={loaded}
            title={window_right_count_info?.name}
            onChange={(id) =>
              handleWindowCountChange(
                'right_wall',
                'pcv',
                'window_right_count',
                id,
                window_right_size_available,
                window_right_size_selected
              )
            }
            options={window_right_count_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          <SelectEdit
            selected={window_right_size_selected}
            loaded={loaded}
            title={window_right_size_info?.name}
            onChange={(id) =>
              handleWindowSizeChange('right_wall', 'pcv', 'window_right_size', id, window_right_size_available)
            }
            options={window_right_size_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          {windows['right_wall']?.pcv?.map((window, index) => (
            <React.Fragment key={`${window.id}_group`}>
              <RangeEdit
                key={`${window.id}_horizontal`}
                title={
                  windows['right_wall'].pcv.length === 1
                    ? t('window_pcv_position_horizontal')
                    : `${t('window_pcv_position_horizontal')} ${index + 1}`
                }
                min={20}
                step={5}
                max={length - 20 - window.width}
                unit={'cm'}
                selected={window.positionHorizontal}
                onChange={(value) => onWindowPositionChange('right_wall', 'pcv', index, 'positionHorizontal', value)}
              />
              <RangeEdit
                key={`${window.id}_vertical`}
                title={
                  windows['right_wall'].pcv.length === 1
                    ? t('window_pcv_position_vertical')
                    : `${t('window_pcv_position_vertical')} ${index + 1}`
                }
                min={50}
                step={5}
                max={secondHeight - 13 - window.height}
                unit={'cm'}
                selected={window.positionVertical ?? 50}
                onChange={(value) => onWindowPositionChange('right_wall', 'pcv', index, 'positionVertical', value)}
              />
            </React.Fragment>
          ))}
          {window_right_count_selected > 0 && window_right_size_selected && (
            <>
              <SelectEdit
                selected={window_right_tilt_selected}
                loaded={loaded}
                title={t('tilt_window_right') || t('tilt_window') || 'Uchylne (prawa)'}
                onChange={(id) => { setSelected('window_right_tilt', id); }}
                options={getTiltOptions(window_right_size_selected)}
                nested
              />
              <SelectEdit
                selected={window_right_color_selected}
                loaded={loaded}
                title={t('window_right_color') || 'Kolor okna (prawa)'}
                onChange={(id) => { setSelected('window_right_color', id); }}
                options={getColorOptions()}
                nested
                info={colorInfo}
              />
            </>
          )}

          {/* FRONT WALL ✅ NA SAMYM KOŃCU */}
          <SelectEdit
            selected={window_front_count_selected}
            loaded={loaded}
            title={window_front_count_info?.name}
            onChange={(id) =>
              handleWindowCountChange(
                'front_wall',
                'pcv',
                'window_front_count',
                id,
                window_front_size_available,
                window_front_size_selected
              )
            }
            options={window_front_count_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          <SelectEdit
            selected={window_front_size_selected}
            loaded={loaded}
            title={window_front_size_info?.name}
            onChange={(id) =>
              handleWindowSizeChange('front_wall', 'pcv', 'window_front_size', id, window_front_size_available)
            }
            options={window_front_size_available.map((el) => ({ id: el.id, value: `${el.value}` }))}
            nested
          />
          {windows['front_wall']?.pcv?.map((window, index) => (
            <React.Fragment key={`${window.id}_group`}>
              <RangeEdit
                key={`${window.id}_horizontal`}
                title={
                  windows['front_wall'].pcv.length === 1
                    ? t('window_pcv_position_horizontal')
                    : `${t('window_pcv_position_horizontal')} ${index + 1}`
                }
                min={20}
                step={5}
                max={width - 20 - window.width}
                unit={'cm'}
                selected={window.positionHorizontal}
                onChange={(value) => onWindowPositionChange('front_wall', 'pcv', index, 'positionHorizontal', value)}
              />
              <RangeEdit
                key={`${window.id}_vertical`}
                title={
                  windows['front_wall'].pcv.length === 1
                    ? t('window_pcv_position_vertical')
                    : `${t('window_pcv_position_vertical')} ${index + 1}`
                }
                min={50}
                step={5}
                max={secondHeight - 13 - window.height}
                unit={'cm'}
                selected={window.positionVertical ?? 50}
                onChange={(value) => onWindowPositionChange('front_wall', 'pcv', index, 'positionVertical', value)}
              />
            </React.Fragment>
          ))}
          {window_front_count_selected > 0 && window_front_size_selected && (
            <>
              <SelectEdit
                selected={window_front_tilt_selected}
                loaded={loaded}
                title={t('tilt_window_front') || t('tilt_window') || 'Uchylne (przód)'}
                onChange={(id) => { setSelected('window_front_tilt', id); }}
                options={getTiltOptions(window_front_size_selected)}
                nested
              />
              <SelectEdit
                selected={window_front_color_selected}
                loaded={loaded}
                title={t('window_front_color') || 'Kolor okna (przód)'}
                onChange={(id) => { setSelected('window_front_color', id); }}
                options={getColorOptions()}
                nested
                info={colorInfo}
              />
            </>
          )}

          <Container>
            <ButtonWrapper>
              <Button
                icon={<InfoCircleOutlined />}
                type="primary"
                block
                onClick={openModal}
              >
                {t('more_information')}
              </Button>
            </ButtonWrapper>
          </Container>
        </EditableSection>
      ) : null}
    </>
  );
};

ConstructionExtras.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  setSelected: PropTypes.func.isRequired,
  loaded: PropTypes.bool,

  window_back_count_available: PropTypes.arrayOf(availableType),
  window_back_count_info: infoShape,
  window_back_count_selected: PropTypes.number,
  window_back_size_available: PropTypes.arrayOf(availableType),
  window_back_size_info: infoShape,
  window_back_size_selected: PropTypes.number,

  window_left_count_available: PropTypes.arrayOf(availableType),
  window_left_count_info: infoShape,
  window_left_count_selected: PropTypes.number,
  window_left_size_available: PropTypes.arrayOf(availableType),
  window_left_size_info: infoShape,
  window_left_size_selected: PropTypes.number,

  window_right_count_available: PropTypes.arrayOf(availableType),
  window_right_count_info: infoShape,
  window_right_count_selected: PropTypes.number,
  window_right_size_available: PropTypes.arrayOf(availableType),
  window_right_size_info: infoShape,
  window_right_size_selected: PropTypes.number,

  // FRONT ✅
  window_front_count_available: PropTypes.arrayOf(availableType),
  window_front_count_info: infoShape,
  window_front_count_selected: PropTypes.number,
  window_front_size_available: PropTypes.arrayOf(availableType),
  window_front_size_info: infoShape,
  window_front_size_selected: PropTypes.number,

  window_back_tilt_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  window_left_tilt_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  window_right_tilt_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  window_front_tilt_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  window_back_color_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  window_left_color_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  window_right_color_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  window_front_color_selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ConstructionExtras.defaultProps = {
  loaded: false,

  window_back_count_available: [],
  window_back_count_info: null,
  window_back_count_selected: null,
  window_back_size_available: [],
  window_back_size_info: null,
  window_back_size_selected: null,

  window_left_count_available: [],
  window_left_count_info: null,
  window_left_count_selected: null,
  window_left_size_available: [],
  window_left_size_info: null,
  window_left_size_selected: null,

  window_right_count_available: [],
  window_right_count_info: null,
  window_right_count_selected: null,
  window_right_size_available: [],
  window_right_size_info: null,
  window_right_size_selected: null,

  // FRONT ✅
  window_front_count_available: [],
  window_front_count_info: null,
  window_front_count_selected: null,
  window_front_size_available: [],
  window_front_size_info: null,
  window_front_size_selected: null,

  window_back_tilt_selected: null,
  window_left_tilt_selected: null,
  window_right_tilt_selected: null,
  window_front_tilt_selected: null,

  window_back_color_selected: null,
  window_left_color_selected: null,
  window_right_color_selected: null,
  window_front_color_selected: null,
};

const mapDispatchToProps = {
  setSelected: setSelectedParameter
};

export default connect(selector, mapDispatchToProps)(withTranslation(ConstructionExtras));
